import { render, staticRenderFns } from "./AddTestPaper.vue?vue&type=template&id=33cbd7fa&scoped=true&"
import script from "./AddTestPaper.vue?vue&type=script&lang=js&"
export * from "./AddTestPaper.vue?vue&type=script&lang=js&"
import style0 from "./AddTestPaper.vue?vue&type=style&index=0&id=33cbd7fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cbd7fa",
  null
  
)

export default component.exports